import React from 'react'
import {Link} from 'gatsby'
import starIcon from '../../assets/images/star-icon.png'
import client1 from '../../assets/images/testimonials/client1.jpg'
import client2 from '../../assets/images/testimonials/client2.jpg'
import client3 from '../../assets/images/testimonials/client3.jpg'
import BlogImg4 from '../../assets/images/blog/blog-img4.jpg'
import BlogImg5 from '../../assets/images/blog/blog-img5.jpg'
import BlogImg6 from '../../assets/images/blog/blog-img6.jpg'
import User1 from '../../assets/images/user1.jpg'
import shape from '../../assets/images/shape/shape1.svg'
import Loadable from '@loadable/component'
import ReactDOM from "react-dom";
const OwlCarousel = Loadable(() => import('react-owl-carousel3'))

const options = {
    loop: true,
    nav: true,
    dots: true,
    autoplayHoverPause: false,
    autoplay: true,
    margin: 10,
    navText: [
        "<i class='flaticon-left-1'></i>",
        "<i class='flaticon-right-1'></i>"
    ],
    responsive: {
        0: {
            items: 1,
        },
        768: {
            items: 1,
        },
        992: {
            items: 1,
        }
    }
};


const Carousel = (props) => {
    const [display, setDisplay] = React.useState(false);

    React.useEffect(() => {
        setDisplay(true);
    }, [])

    const carouselItem = props.carousel.carousel;

    return (
        <div style={{ width: `100%` }}>
            {carouselItem.length > 0  ?
                <div>
                    {carouselItem.length > 1 ?
                        <div className="pt-100" id="carouselBanner">
                            <div className="container">
                                {display ? <OwlCarousel
                                        className="testimonials-slides owl-carousel owl-theme"
                                        {...options}
                                    >

                                        {carouselItem.map((item, idx) => {
                                            return (
                                                <div className="single-carousel-item" key={idx}>
                                                    <div className="single-blog-post bg-fffbf5">
                                                        <div className="post-image">
                                                            <a href={item.url} target="_blank">
                                                                <img src={item.image.url} alt="Blog" />
                                                            </a>
                                                        </div>

                                                        {item.title ?
                                                            <div className="post-content">
                                                                <h3>
                                                                    <a href={item.url} target="_blank">
                                                                        {item.title}
                                                                    </a>
                                                                </h3>
                                                            </div>
                                                            : ''}
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </OwlCarousel> :
                                    <div className="single-carousel-item">
                                        <div className="single-blog-post bg-fffbf5">
                                            <div className="post-image">
                                                <a href="asdfasf" target="_blank">
                                                    <img src={BlogImg6} alt="Blog" />
                                                </a>
                                            </div>
                                            <div className="post-content">
                                                <h3>
                                                    <a href="·asdfsadf" target="_blank">
                                                        "tittle"
                                                    </a>
                                                </h3>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                            <div className="shape-img1">
                                <img src={shape} alt="testimonial" />
                            </div>
                        </div>
                        :
                        <div className="container">
                            {carouselItem.map((item, idx) => {
                                return (
                                    <div className="single-carousel-item" key={idx}>
                                        <div className="single-blog-post bg-fffbf5">
                                            <div className="post-image">
                                                <a href={item.url} target="_blank">
                                                    <img src={item.image.url} alt="Blog" />
                                                </a>
                                            </div>

                                            {item.title ?
                                                <div className="post-content">
                                                    <h3>
                                                        <a href={item.url} target="_blank">
                                                            {item.title}
                                                        </a>
                                                    </h3>
                                                </div>
                                                : ''}
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    }
                </div>
                : '' }
        </div>
    )
}

export default Carousel;
